export { default as Img200 } from './processed/200/The-Hot-Zone.jpg';
export { default as Img400 } from './processed/400/The-Hot-Zone.jpg';
export { default as Imgthumb } from './processed/thumb/The-Hot-Zone.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/The-Hot-Zone.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/The-Hot-Zone.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      251,
      44,
      20
    ],
    "_population": 22709,
    "_hsl": [
      0.017316017316017316,
      0.9665271966527196,
      0.5313725490196078
    ]
  },
  "LightVibrant": {
    "_rgb": [
      252,
      156,
      140
    ],
    "_population": 6,
    "_hsl": [
      0.023809523809523808,
      0.9491525423728815,
      0.7686274509803922
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      136,
      20,
      4
    ],
    "_population": 998,
    "_hsl": [
      0.020202020202020204,
      0.9428571428571426,
      0.27450980392156865
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/The-Hot-Zone.js